import { getParameterByName } from "../helpers/getParameter";
import { priceWrapper } from "../offer-table/priceWrapper";

const searchBtn = document.querySelector('[data-btn="searchInput"]');

Vue.component("input-search", {
	delimiters: ["{[{", "}]}"],
	props: [
		"datasearchredirect",
		"dataprompturl",
		"datafastlinksurl",
		"indexsearch",
		"indexprompt",
		"popularsearches",
		"knowledge",
		"culture",
		"placeholder",
		"fastlinkelements",
		"type",
		"alwaysredirect",
		"fastlinkstext",
		"promptstext",
		"srsearch",
		"buttonid",
	],
	data: function () {
		return {
			helpSearchApp: "",
			searchInput: "",
			disabledSubmit: true,
			showlinks: false,
			fastlinks: false,
			linksdata: "",
			linksheading: "",
			knowledgedata: "",
			knowledgeheading: "",
			fastlinksUrl: "",
			prompts: "",
			promptUrl: "",
			dataMethod: "",
			searchText: "",
			counter: 0,
			results: "",
			pages: 0,
			showResults: false,
			searchUrl: "",
			dataRedirect: "",
			onStart: "",
			index_prompt: "",
			index_search: "",
			index_popular: "",
			index_knowledge: "",
			index_culture: "",
			myTimeout: "",
			isOpen: false,
		};
	},
	mounted: function () {
		this.helpSearchApp = this.$refs.helpSearchApp;
		this.promptUrl = this.helpSearchApp.getAttribute("data-prompt-url");
		this.dataMethod = this.helpSearchApp.getAttribute("data-method");
		this.searchUrl = this.helpSearchApp.getAttribute("data-search-url");
		this.fastlinksUrl = this.helpSearchApp.getAttribute("data-fastlinks-url");
		this.dataRedirect = this.helpSearchApp.getAttribute("data-search-redirect");
		this.onStart = this.helpSearchApp.getAttribute("data-onstart");
		this.close = this.helpSearchApp.getAttribute("data-popup-close");

		this.index_prompt = this.$refs.index_prompt.value;
		this.index_search = this.$refs.index_search.value;
		this.index_popular = this.$refs.index_popular.value;
		this.index_knowledge = this.$refs.index_knowledge.value;
		this.index_culture = this.$refs.index_culture.value;

		const pagePar = parseInt(getParameterByName("page"));
		if (getParameterByName("search")) {
			if (getParameterByName("type") == this.type && this.onStart != "no") {
				this.searchInput = getParameterByName("search");
				this.onSubmit(pagePar, true);
			}
		}
		let that = this;
		$(document).click(function (event) {
			if (that.isOpen && event.target !== $('[data-btn="searchInput"]')[0]) {
				that.isOpen = false;
				that.searchInput = "";
				that.prompts = "";
			}
		});

		const searchBtn = $('[data-btn="searchInput"]');

		$('[data-btn="searchInput"]').click(function () {
			that.isOpen = !that.isOpen;
			that.showFastlinks();
			setTimeout(() => {
				document.querySelector('input[name="searchHelp"]').focus();
			}, 100);
			// console.log("searchBtn", searchBtn)
			// if (that.isOpen) {
			// 	searchBtn.ariaExpanded = "false"
			// 	console.log("searchBtn", searchBtn.ariaExpanded)
			// } else {
			// 	searchBtn.ariaExpanded = "true"
			// 	console.log("searchBtn", searchBtn.ariaExpanded)
			// }
		});

		window.addEventListener('keydown', this.handleEscape);
	},
	updated: function () {
		if (this.searchInput.length > 0) {
			this.disabledSubmit = false;
		}
	},
	watch: {
		isOpen(newVal) {
			window.dispatchEvent(new CustomEvent('search-toggled', {
					detail: { isOpen: this.isOpen }
					}));
			// const searchBtn = $('[data-btn="searchInput"]');
			// if (searchBtn) {
			// 	// searchBtn.setAttribute('aria-expanded', String(newVal));
			// 	// searchBtn.ariaExpanded =  String(newVal);
			// 	// searchBtn.classList.add("ariaa")
			// 	// console.log('searchBtn', searchBtn, newVal)
			// 	window.dispatchEvent(new CustomEvent('search-toggled', {
			// 		detail: { isOpen: this.isMenuOpen }
			// 		}));
			// }
		}
	},
	methods: {
		showLinks: function (event) {
			// console.log("this.searchInput.length", this.searchInput.length);
			// console.log("this.fastlinks", this.fastlinks);
			if (this.searchInput.length > 2) {
				this.fastlinks = false;
				this.showPrompt(event);
			}
			if (this.searchInput.length === 0 || this.searchInput.length > 2) {
				this.showlinks = true;
			}
		},
		hideLinks: function (event) {
			this.showlinks = false;
			event.stopPropagation();
		},
		showFastlinks: function () {
			if (!this.fastlinksdata) {
				const that = this;
				async function fetchData() {
					const response = await fetch(that.fastlinksUrl);
					if (!response.ok) {
						const message = `An error has occured: ${response.status}`;
						throw new Error(message);
					}
					const data = await response.json();
					const fastlinksdata = data.links;
					const knowledgedata = data.knowledge;
					const linksheading = data.linksheading;
					const knowledgeheading = data.knowledgeheading;
					return [fastlinksdata, knowledgedata, linksheading, knowledgeheading];
				}
				fetchData()
					.then(([fastlinksdata, knowledgedata, linksheading, knowledgeheading]) => {
						that.fastlinksdata = fastlinksdata;
						that.knowledgedata = knowledgedata;
						that.knowledgeheading = knowledgeheading;
						that.linksheading = linksheading;
						// console.log("fastlinksdata", this.fastlinksdata);
						if (that.fastlinksdata) {
							this.fastlinks = true;
						}
					})
					.catch((error) => {
						error.message;
					});
			} else {
				this.fastlinks = true;
			}
		},
		showPrompt: function (event) {
			if (event.target === document.activeElement) {
				this.showlinks = true;
				this.searchInput = event.target.value;
			}
			const that = this;
			if (this.searchInput.length > 0) {
				this.disabledSubmit = false;
			} else {
				this.disabledSubmit = true;
			}
			if (this.searchInput.length > 2) {
				this.fastlinks = false;
				const that = this;
				const xhttp = new XMLHttpRequest();
				xhttp.onreadystatechange = function () {
					if (this.readyState == 4 && this.status == 200) {
						that.prompts = JSON.parse(this.responseText);
					} else if (this.readyState == 4 && this.status != 200) {
					}
				};
				xhttp.open(this.dataMethod, this.promptUrl);
				xhttp.setRequestHeader("Content-Type", "application/json");
				clearTimeout(this.myTimeout);
				this.myTimeout = setTimeout(function () {
					xhttp.send(
						JSON.stringify({
							search: that.searchInput,
							index: that.index_prompt,
							popularsearches: that.index_popular,
							knowledge: that.index_knowledge,
							culture: that.index_culture,
						})
					);
				}, 500);
			} else {
				this.fastlinks = true;
			}
		},
		onSubmit: function (pagenumber, nohistory) {
			const elem = this.$refs.searchInput;
			elem.blur();
			// console.log('onSubmit', this.dataRedirect, 'this.onStart=', this.onStart, 'this.type=', this.type);

			if (this.disabledSubmit) {
				this.isOpen = false;
			} else {
				if (
					this.alwaysredirect == "true" ||
					(this.dataRedirect && this.onStart != "no")
				) {
					window.location.href =
						this.dataRedirect +
						"?search=" +
						encodeURIComponent(this.searchInput) +
						"&type=" +
						this.type +
						"&page=" +
						pagenumber;
				} else {
					this.onStart = "";
					// console.log('submit');
					const that = this;

					const xhttp = new XMLHttpRequest();
					xhttp.onreadystatechange = function () {
						if (this.readyState == 4 && this.status == 200) {
							that.results = JSON.parse(this.responseText);
							that.pages = that.results.pages;
							that.counter = that.results.results_count;
							that.showResults = true;
							that.searchText = that.searchInput;
							if (pagenumber >= that.pages) {
								pagenumber = 0;
							}
							if (!nohistory) {
								history.pushState(
									null,
									null,
									"?search=" +
										encodeURIComponent(that.searchInput) +
										"&type=" +
										that.type +
										"&page=" +
										pagenumber
								);
							}
							for (let result in that.results.results) {
								for (let subject in that.results.results[result].subjects) {
									let sub = that.results.results[result].subjects[subject];
									let regEx = new RegExp(`(${that.searchText})`, "gi");
									sub.description = String(sub.description).replace(
										regEx,
										"<strong>$1</strong>"
									);

									// that.counter++;
								}
							}
							that.$emit("send-form", {
								showResults: that.showResults,
								results: that.results,
								searchText: that.searchText,
								counter: that.counter,
								page: pagenumber,
							});
							that.$root.showLoader = false;
						} else if (this.readyState == 4 && this.status != 200) {
							that.$root.showLoader = false;
						}
					};
					that.$root.showLoader = true;
					xhttp.open(this.dataMethod, this.searchUrl);
					xhttp.setRequestHeader("Content-Type", "application/json");
					// console.log({'search': this.searchInput, 'knowledge': this.index_knowledge, 'popular': this.index_popular, 'index': this.index_search, 'page': pagenumber });
					xhttp.send(
						JSON.stringify({
							search: this.searchInput,
							index: this.index_search,
							page: pagenumber,
						})
					);
				}
			}
		},
		handleEscape: function(event) {
			if (event.key === "Escape" && this.isOpen) {
				this.isOpen = false;
			}
		},
	},
	template: `<div class="popup-b2b search" :class="[{'is-active': isOpen}]" role="dialog" aria-modal="true" aria-labelledby="dialog1_label_search" id="search-main-b2b">
	<div class="sr-only" id="dialog1_label_search">Wyszukiwarka</div>
	<div class="search__body-container">
		<div role="form" autocomplete="off" ref="helpSearchApp" data-method="POST" :data-search-redirect="datasearchredirect" :data-prompt-url="dataprompturl" :data-fastlinks-url="datafastlinksurl">
			<input type="hidden" ref="index_prompt" :value="indexprompt">
			<input type="hidden" ref="index_search" :value="indexsearch">
			<input type="hidden" ref="index_popular" :value="popularsearches">
			<input type="hidden" ref="index_knowledge" :value="knowledge">
			<input type="hidden" ref="index_culture" :value="culture">
			<label :for="'searchHelp-'+type" id="searchHelpLabel" class="sr-only">{[{srsearch}]}</label>
			<input @keyup.enter="onSubmit(0);showlinks=true;" @focus="showLinks($event)" @input="showPrompt($event)" ref="searchInput" :value="searchInput" name="searchHelp" :id="'searchHelp-'+type" type="search" aria-controls="" :placeholder="placeholder" autocomplete="off">
			<button @click="onSubmit(0)" class="help-search__submit" type="button" value="" aria-label="Szukaj" :id="buttonid" :data-popup-close="close"></button>
			<div class="help-search__list" v-if="((fastlinks && fastlinksdata) || (!fastlinks && prompts.success && prompts.results.length))" id="searchResults">
				<span class="help-search__line" v-if="!fastlinks && prompts.results">{[{promptstext}]}</span>
				<div class="help-search__fastlink" v-if="fastlinks && fastlinksdata">
					<span class="help-search__line">{[{linksheading}]}</span>
					<ul class="help-search__results">
						<li v-for="fastlink in fastlinksdata" class="help-search__item">
							<a :href="fastlink.link" class="top-products-item">
								<span v-if="fastlink.color" class="top-products-item__boxcolor" :style="{ 'background-color': fastlink.color }" ></span>
								<div class="top-products-item__text">
									<h3 class="top-products-item__title">{[{fastlink.title}]}</h3>
									<span class="top-products-item__description">{[{fastlink.description}]}</span>
								</div>
							</a>
						</li>
					</ul>
				</div>
				<div class="help-search__fastlink" v-if="fastlinks && knowledgedata">
					<span class="help-search__line">{[{knowledgeheading}]}</span>
					<ul class="help-search__results">
						<li v-for="link in knowledgedata" class="help-search__item">
							<a :href="link.link" class="top-products-item">
								<img v-if="link.img" class="top-products-item__img" :src="link.img" alt="">
								<div class="top-products-item__text">
									<h3 class="top-products-item__title">{[{link.title}]}</h3>
									<span class="top-products-item__description">{[{link.description}]}</span>
								</div>
							</a>
						</li>
					</ul>
				</div>
				<ul class="help-search__results" v-if="!fastlinks && prompts.success">
					<li v-for="result in prompts.results" class="help-search__item">
						<a v-if="result.description" :href="result.link" class="top-products-item">
							<span v-if="result.color" class="top-products-item__boxcolor" :style="{ 'background-color': result.color }"></span>
							<div class="top-products-item__text">
								<h3 class="top-products-item__title">{[{result.title}]}</h3>
								<span class="top-products-item__description">{[{result.description}]}</span>
							</div>
						</a>
						<a v-else :href="result.link" class="help-search--title">{[{result.title}]}</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>`,
});
